import React from 'react';
import { useSelector } from 'react-redux';
import { SENSORS } from '../../config';
import styles from './SystemDetails.module.css';
import SensorsGraphWithOptions from './SensorsGraphWithOptions';

function SystemGraphCard({ systemId }) {
  const system = useSelector((state) => state.bessReducer.details[systemId]);

  let sensors = [
    SENSORS.Power,
    SENSORS.Current,
    SENSORS.Temperature,
    SENSORS.Voltage
  ];

  sensors = sensors.map((sensor) => {
    const sensorIds = system.sensors
      .filter(
        (potentialSensor) => potentialSensor.sensorTypeName === sensor.name
      )
      .map((correctSensor) => correctSensor.deviceSensorId);
    return { ...sensor, ids: sensorIds };
  });

  return (
    <div className={styles.systemGraphCard}>
      <SensorsGraphWithOptions
        showDots={true}
        systemId={systemId}
        sensors={sensors}
        height={'65vh'}
      />
    </div>
  );
}

export default SystemGraphCard;
